import { removeItem, insertItem, filterItems, optionExists } from '../utils';
import { Actions, TagOptionRecord, TagSelectInputState } from '../types';

export function tagSelectInputReducer<T extends TagOptionRecord>(
  state: TagSelectInputState<T>,
  action: Actions<T>,
): TagSelectInputState<T> {
  switch (action.type) {
    case 'SELECT_SINGLE_OPTION': {
      const { keyField, option, isSelected } = action;
      if (isSelected) {
        return {
          ...state,
          selectedOptions: removeItem(state.selectedOptions, option, keyField),
        };
      }

      if (state.selectedOptions.length === state.maxSelected) {
        return {
          ...state,
        };
      }

      return {
        ...state,
        selectedOptions: insertItem(state.selectedOptions, option),
      };
    }

    case 'REMOVE_SINGLE_OPTION': {
      const { keyField, valueField, option } = action;
      return {
        ...state,
        selectedOptions: removeItem(
          state.selectedOptions,
          option,
          keyField,
          valueField,
        ),
      };
    }

    case 'ADD_NEW_OPTION': {
      if (state.selectedOptions.length === state.maxSelected) {
        return {
          ...state,
        };
      }
      const { valueField, value } = action;
      const currentCheck = optionExists(state.options, value, valueField);

      if (currentCheck !== -1) {
        return {
          ...state,
          selectedOptions: insertItem(
            state.selectedOptions,
            state.options[currentCheck],
          ),
        };
      }

      const newOption = valueField
        ? Object.assign({}, { [valueField]: value })
        : value;

      return {
        ...state,
        selectedOptions: insertItem(state.selectedOptions, newOption as T),
      };
    }

    case 'CHANGE_OPTION_VISIBILITY': {
      const { visibility, showOnFocus } = action;
      if (showOnFocus && visibility) {
        return {
          ...state,
          optionsVisiable: visibility,
          filteredOptions: state.options.slice(
            0,
            state.options.length > 5 ? 4 : undefined,
          ),
        };
      } else {
        return {
          ...state,
          optionsVisiable: visibility,
        };
      }
    }

    case 'FILTER_TAGS': {
      const { value, valueField } = action;
      return {
        ...state,
        filteredOptions: filterItems(state.options, value, valueField),
      };
    }

    case 'SET_DATA_OPTIONS': {
      const { data, selected } = action;
      return {
        ...state,
        options: data,
        selectedOptions: selected,
      };
    }

    default: {
      throw new Error(`Unhandeled action type: ${action.type}`);
    }
  }
}
